import Axios from "axios";

export default function handleClosePref(c_id){
   // console.log(counsellingYear);
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'handleClosePref',  
            c_id      
          
        }
    });
    return response;
}